import classNames from "classnames"
import s from '../../index.module.css';
import classes from './index.module.css';
import { createContext, useEffect, useState } from "react";
import { getInitialState } from "./initState";
import { useDispatch, useSelector } from "react-redux";
import { selectProfile } from "@store/profile.reducer";
import { FormatLesson } from "./components/FormatLesson";
import { IntervalType } from "./components/IntervalType";
import { ConferenceType } from "./components/ConferenceType";
import { CourseSelection } from "./components/CourseSelection";
import { SeminarianSelection } from "./components/SeminarianSelection";
import { SeminarianSelectionForConferenceTypeCustomizable } from "./components/SeminarianSelectionForConferenceTypeCustomizable";
import { LinkToMeeting } from "./components/LinkToMeeting";
import { AudienceNumber } from "./components/AudienceNumber";
import { Groups } from "./components/Groups";
import { Date } from "./components/Date";
import { StartDate } from "./components/StartDate";
import { EndDate } from "./components/EndDate";
import { Time } from "./components/Time";
import { Name } from "./components/Name";
import { ChoiceRegularity } from "./components/ChoiceRegularity";
import { AdditionalSettings } from "./components/AdditionalSettings";
import { Childrens } from "./components/Childrens";
import { Tariff } from "./components/Tariff";
import { Customizable } from "./components/Customizable";
import setSettingsFromServer from "@/helpers/setSettingsFromServer";
import { timetableBeta, usersAPI } from "@/api";
import useLoad from "@/hooks/useLoad";
import { formateName } from "@/helpers/formateName";
import { intervalTypesEnum } from "./components/IntervalType/intervalTypesEnum";
import { conferenceTypesEnum } from "./components/ConferenceType/conferenceTypesEnum";
import Button from "@UI/New/Button";
import { ScheduleInGoogleCalendar } from "./components/ScheduleInGoogleCalendar";
import { closeAllModal } from "@store/modalsSlise";
import { useAddAlert } from "@/hooks/useAddAlert";
import { fetchTimetableData } from "@store/timetable/fetchTimetableData";
import useRoles from "@/hooks/useRoles";
import { valid } from "./helpers/valid";
import { LinkToMeetingForChildren } from "./components/LinkToMeetingForChildren";

export const ModalSettingContext = createContext(null);

const AddLessonOrMeeting = () => {
    const dispatch = useDispatch()
    const addAlert = useAddAlert()
    const profile = useSelector(selectProfile);
    const [settings, setSettings] = useState(null)
    useEffect(() => {
        setSettingsFromServer(setSettings)
    }, [])
    const duplicateInGoogleCalendar = settings?.duplicateInGoogleCalendar == '1';
    const isSeparateLinksForStudentsAndTeachers = settings?.isSeparateLinksForStudentsAndTeachers == '1';
    
    const [state, setState] = useState(getInitialState({profile}));
    const setFieldInState = ({field, value, resetFields=[]}) => {
        setState((prevState) => (
            {
                ...prevState,
                [field]: value,
                ...resetFields.reduce((acc, key) => {
                    acc[key] = getInitialState({profile})[key];
                    return acc;
                }, {})
            }
        ))
    }

    const toggleStudentInUnavailableStudents = (id) => {
            setState((prevState) => {
                const value = prevState.unavailableStudents.includes(id);
                
                const newUnavailableStudents = value ? 
                    prevState.unavailableStudents.filter(iterId => iterId !== id) 
                    :
                    [...prevState.unavailableStudents, id];

                const newState = {
                    ...prevState,
                    unavailableStudents: newUnavailableStudents
                }

                return newState;
            }
        )
    }

    useEffect(() => {
        if(settings === null) return;
        setState((prevState) => (
            {
                ...prevState,
                scheduleInGoogleCalendar: !!settings?.duplicateInGoogleCalendar
            }
        ))
    }, [settings?.duplicateInGoogleCalendar])
    
    const { 
        state: courseSeminarians, 
        setState: setCourseSeminarians, 
        getState: getCourseSeminarians, 
        loading: loadingCourseSeminarians 
    } = useLoad({
        api: usersAPI.getSeminarian,
        params: {
          direction_id: state.direction,
          status: 10,
          expand: [`seminarian`],
          pageSize: false,
        },
        key: "data",
        initState: [],
        last: false,
    });

    useEffect(() => {
        if(!state.direction) {
            setCourseSeminarians([]);
            return;
        }
        getCourseSeminarians()
    }, [state.direction])

    const courseSeminariansList = courseSeminarians?.filter(({ seminarian }) => seminarian.status === 10) //to correct убрать сортировку, если на бэке будет работать
        ?.map(({ seminarian }) => ({
        label: formateName(seminarian.name, "F I"),
        value: seminarian.id,
    }))

    const [sending, setSending] = useState(false);

    const add = () => {
        const validValue = valid({state});
        
        if(!validValue?.value){
            addAlert({title: 'Ошибка', text: validValue.text, type: 'error'})
            return;
        }
        const {speaker_id, customDaysValue, time, direction, seminariansСlasses, date_conference, start_date, end_date, inRecording, isOffline, ...newData} = state;
        
        const sentDate = {
            ...newData,
            seminariansСlasses: [
                ...seminariansСlasses.filter(el => el !== speaker_id).map((el) => {
                   return (
                    {
                        speaker_id: el,
                        main: false
                    }
                   )
                }),
                ...(speaker_id ? [
                    {
                        speaker_id, 
                        main: true
                    }
                ] : []) 
            ],
            speaker_id: speaker_id ?? null,
            start_date: intervalTypesEnum.oneTime === state.interval_type ? state.date_conference : start_date,
            end_date: intervalTypesEnum.oneTime === state.interval_type ? state.date_conference : end_date,
            ...(intervalTypesEnum.customDays !== state.interval_type && {
                start_time: time.start_time,
                end_time: time.end_time,
            }),
            ...(intervalTypesEnum.customDays === state.interval_type && {
                customDaysValue
            }),
            direction_id: direction,
            isOffline: isOffline ? 1 : 0,
            inRecording: inRecording ? 1 : 0
        };
        setSending(true);
        timetableBeta.addLesson({data: sentDate})
            .then(({data})=>{
                if(data.status==='success'){
                    addAlert({title:'Успешно', text: 'Занятие добавлено'})
                    dispatch(fetchTimetableData())
                    dispatch(closeAllModal())
                }
            })
            .finally(() => setSending(false))
    }

    const [profileSelectedSpeaker, setProfileSelectedSpeaker] = useState(null);

    useEffect(() => {
        if(state.speaker_id){
            usersAPI.getUser({ 
                id: state.speaker_id, 
                expand: ["userProfile"] 
            })
            .then(({data})=>{
                setProfileSelectedSpeaker(data)
            })
        }
        else{
            setProfileSelectedSpeaker(null)
        }
    }, [state.speaker_id])

    useEffect(()=>{
        if(profileSelectedSpeaker){
            setFieldInState({value: profileSelectedSpeaker?.userProfile?.url_conference ?? '', field: 'link_to_meeting'})
            if(isSeparateLinksForStudentsAndTeachers){
                setFieldInState({value: profileSelectedSpeaker?.userProfile?.url_conference_for_children ?? '', field: 'link_to_meeting_for_children'})
            }
        }
        else{
            setFieldInState({value: getInitialState({profile}).link_to_meeting, field: 'link_to_meeting'})
            if(isSeparateLinksForStudentsAndTeachers){
                setFieldInState({value: getInitialState({profile}).link_to_meeting_for_children, field: 'link_to_meeting_for_children'})
            }
        }
    }, [profileSelectedSpeaker])
    
    const { isAdminOrJuniorAdmin } = useRoles();

    return (
        <ModalSettingContext.Provider 
            value={
                {
                    state, 
                    setState, 
                    setFieldInState, 
                    settings, 
                    toggleStudentInUnavailableStudents,
                    courseSeminariansList,
                    loadingCourseSeminarians
                }
            }>
            <div className={classNames(s.modalContainer, classes.modalContainer)}>
                <div className={s.modalHeader}>
                <div className={s.modalTitleContainer}>
                    <span className={s.modalHeaderBigTitle}>
                        Добавить урок / встречу
                    </span>
                </div>
                </div>
                <div className={classNames(s.contentWrapper, classes.contentWrapper)}>
                    <FormatLesson />
                    <ConferenceType />
                    <IntervalType />

                    {
                        state.interval_type === intervalTypesEnum.customDays && (
                            <ChoiceRegularity />
                        )
                    }
                    
                    <div className={classes.wrapper}>
                        {
                            state.conference_type === conferenceTypesEnum.customizable ? (
                                <>
                                    <Name />
                                    <SeminarianSelectionForConferenceTypeCustomizable />
                                </>
                            ) : (
                                <>
                                    <CourseSelection />
                                    {
                                        isAdminOrJuniorAdmin && <SeminarianSelection /> 
                                    }
                                </>
                            )
                        }
                        
                        
                    </div>
                    {/* {
                        state.conference_type === conferenceTypesEnum.private && (
                            <Tariff />
                        )
                    } */}
                    {
                        state.isOffline ? (
                            <AudienceNumber />
                        ) : (
                            <>
                                <LinkToMeeting />
                                {
                                    settings?.isSeparateLinksForStudentsAndTeachers == '1' && <LinkToMeetingForChildren />
                                }
                            </>
                        )
                    }
                    {
                        state.conference_type === conferenceTypesEnum.group && (
                            <Groups />
                        )
                    }
                    {
                        state.conference_type === conferenceTypesEnum.private && (
                            <Childrens />
                        )
                    }
                    {
                        state.conference_type === conferenceTypesEnum.customizable && (
                            <Customizable />
                        )
                    }
                    {
                        (state.interval_type === intervalTypesEnum.regular || 
                         state.interval_type === intervalTypesEnum.biweekly) && (
                            <>
                                <div className={classes.wrapper}>
                                    <StartDate />
                                    <EndDate />
                                </div>
                                <div className={classes.wrapper}>
                                    <Time />
                                    <div style={{width: '100%', padding: '12px'}}></div>
                                </div>
                            </>
                        )
                    }
                    {
                        state.interval_type === intervalTypesEnum.customDays && (
                            <>
                                <div className={classes.wrapper}>
                                    <StartDate />
                                    <EndDate />
                                </div>
                            </>
                        )
                    }
                    {
                        state.interval_type === intervalTypesEnum.oneTime && (
                            <div className={classes.wrapper}>
                                <Date />
                                <Time />
                            </div>
                        )
                    }
                    
                    {
                        duplicateInGoogleCalendar && <ScheduleInGoogleCalendar />
                    }
                    {
                        state.conference_type !== conferenceTypesEnum.customizable && (
                            <AdditionalSettings />
                        )
                    }
                    
                    <Button
                        className={classes.button}
                        color='secondary'
                        onClick={add} 
                        isLoading={sending}
                        disabled={sending}
                    >
                        Добавить изменения
                    </Button>
                </div>
                
            </div>
        </ModalSettingContext.Provider>
    )
}
export default AddLessonOrMeeting;